import { IEvent, IHost } from "@Interfaces";
import { IEventModule } from "@Modules/eventPage/root/IEventModule";
import { QUERY_PARAMS } from "@Utils";

export const getShowUpsellListings = ({
    hostData,
    eventData,
    disablePayment,
    urlQueryParams,
}: {
    hostData: IHost.IHostData;
    eventData?: IEvent.IEventData;
    disablePayment: boolean;
    urlQueryParams: IEventModule.IProps["urlQueryParams"];
}) => {
    const dynamicLink = urlQueryParams?.[QUERY_PARAMS.DYNAMIC_LINK] as string;

    return (
        (eventData?.upsell_exists ?? false) &&
        !disablePayment &&
        !dynamicLink &&
        !hostData?.is_cart_enabled // only show upsell feature when cart is disabled
    );
};
